import React, { useEffect, useState } from "react";
import { Row, Col, notification } from "antd";
import UserDrawer from "../../components/drawer/UserDrawer";
import { IndividualConversationStyle } from "./IndividualConversationStyle";
import { getConversationsSentiments, getUser } from "../../api/password";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../onboarding/UserOnboardingPage.css";
import "./PreviousConversationsStyle.css";
import myFriendLogo from "../../assets/images/my-friend-logo.png";
import myFriendText from "../../assets/images/my_friend_text.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import ProfileIcon from "../../assets/images/Drawer_Image.svg";
import PrinterIcon from "../../assets/images/printer.svg";
import moment from "moment";
import { getRequest } from "../../api";
const IndividualConversation = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const amazonSessionId = useParams();
    const [conversation, setConversation] = useState([]);
    const [nameOfUser, setNameOfUser] = useState("User");
    const [loader, setLoader] = useState(true);
    const [dateCreated, setDateCreated] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const { conversationData } = location.state || {};


    const [selectedVoice, setSelectedVoice] = useState('Amy');
    const userId = Number(localStorage.getItem('userid')); 
    
    
    useEffect(() => {
      const fetchAvatar = async () => {
        try {
          const response = await getRequest('/user/get-avatar');
    
          if (response.error) {
            console.error("Error fetching avatar:", response.error);
            setSelectedVoice('Amy');
          } else {
            const avatar = response.avatar;
    
            if (avatar === 'Arthur' || avatar === 'Amy' || avatar === 'Sam') {
              setSelectedVoice(avatar); 
            } else {
              setSelectedVoice('Amy'); 
            }
          }
        } catch (error) {
          console.error("Error fetching avatar:", error);
          setSelectedVoice('Amy'); 
        }
      };
    
      if (userId) {
        fetchAvatar();
      } else {
        console.error("User ID is missing in localStorage.");
        setSelectedVoice('Amy'); 
      }
    }, [userId]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoader(true);
                const responseName = await getUser();
                setNameOfUser(responseName.name);
                const response = await getConversationsSentiments(amazonSessionId.id);
                setConversation(response.Item.Conversation);
                if (conversationData && conversationData.dateCreated) {
                    const formattedDate = moment(conversationData.dateCreated).fromNow();
                    setDateCreated(formattedDate);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            } finally {
                setLoader(false);
            }
        };
        fetchData();
    }, [amazonSessionId, conversationData]);
    const openDrawer = () => {
        setIsDrawerOpen(true);
    };
    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };
    const removeMiscellaneousText = (text) => {
      if (!text) {
        return "";
      }
      let cleanedText = text
        .replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          ""
        )
        .trim();
      cleanedText = cleanedText.replace(/^(Kano\s*:?"?\s*)/, "");
      return cleanedText;
    };

    const sanitizeJsonString = (jsonString) => {
      let sanitized = jsonString.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").trim();
      return sanitized;
    };

    const jsonFormatter = (item) => {
      try {
        const sanitizedContent = sanitizeJsonString(item.content);
        
        const parsedContent = JSON.parse(sanitizedContent);

        if (parsedContent.message) {
          return removeMiscellaneousText(parsedContent.message);
        }
      } catch (error) {
        console.error("JSON parsing error:", error, "Original Content:", item.content);
      }

      return "Error: Invalid JSON content";
    };

    const handlePrintConversation = async () => {
        try {
            let formattedText = conversation.map((item) => {
                const message = jsonFormatter(item);
                // const roleName = item.role === "assistant" ? `${selectedVoice}` : item.role === "user" ? nameOfUser || "User" : "No role";
                const roleName = item.role === "assistant" ? `My Friend` : item.role === "user" ? nameOfUser || "User" : "No role";
                return `Role: ${roleName}\nContent: ${message || "No content"}\n\n`;
            }).join('\n');
    
            const printWindow = window.open("", "", "height=600,width=800");
            printWindow.document.write(`
                <html>
                <head>
                    <title>Print Conversation</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        pre { white-space: pre-wrap; }
                    </style>
                </head>
                <body>
                    <h1>Conversation with My Friend</h1>
                    <pre>${formattedText}</pre>
                    <script>
                        window.onload = function() {
                            window.print();
                            window.onafterprint = function() {
                                window.close();
                            }
                        }
                    </script>
                </body>
                </html>
            `);
    
            printWindow.document.close();
            printWindow.focus();
    
        } catch (err) {
            console.error("Error printing conversation:", err);
            notification.error({
                message: "Error",
                description: "Failed to print conversation",
                duration: 10
            });
        }
    };
    function handleGoBackButton() {
        navigate("/previous-conversation");
    }
    // function sanitizeJsonString(jsonString) {
    //     return jsonString.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");
    // }
    return (
        <>
            <div>
                <Row className="onboarding-page-section">
                    <Col flex="10%" className="go-back-button">
                        <button onClick={handleGoBackButton} className="button-styling">
                            <img src={goBackButton} alt="Go Back Button" />
                        </button>
                    </Col>
                    <Col flex="80%" className="my-friend-text">
                        <img src={myFriendText} alt="My Friend Text" />
                        <img style={IndividualConversationStyle.logoStyle} src={myFriendLogo} alt="my-friend-log" />
                    </Col>
                    <Col flex="10%" className="search-button">
                        <img
                            src={ProfileIcon}
                            alt="Profile Icon"
                            onClick={openDrawer}
                            style={{ cursor: 'pointer' }}
                        />
                        {isDrawerOpen && (
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        )}
                    </Col>
                </Row>
                <Row justify={"center"}>
                    {isDrawerOpen && (
                        <Col span={4}>
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        </Col>
                    )}
                </Row>
                <Row style={{ justifyContent: "flex-end", paddingRight: "10%" }} >
                    <img src={PrinterIcon} alt="Printer Icon" onClick={() => { handlePrintConversation(); }} />
                </Row>
            </div>
            <Col span={24} style={{ paddingLeft: "9%", paddingRight: "9%" }}>
                <div style={{ width: '100%' }}>
                    {conversation.map((item, index) => {
                        let message = jsonFormatter(item);
                        let timeElement = null;
                        if (item.role === 'user' && item.time) {
                            timeElement = (
                                <span style={{ display: "block", textAlign: "right", color: '#49B0E2' }}>
                                    {moment(item.time).format("DD/MM/YYYY HH:mm:ss")}
                                </span>
                            );
                        }
                        return (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    justifyContent: item.role === 'assistant' ? 'flex-start' : 'flex-end'
                                }}
                            >
                                <div style={{
                                    ...IndividualConversationStyle.conversationStyle,
                                    borderColor: item.role === 'assistant' ? '#EA4C89' : '#49B0E2'
                                }}>
                                    <p style={{
                                        ...IndividualConversationStyle.nameStyle,
                                        color: item.role === 'assistant' ? '#EA4C89' : '#49B0E2'
                                    }}>
                                        {/* {item.role === 'assistant' ? `${selectedVoice}` : nameOfUser}: */}
                                        {item.role === 'assistant' ? `My Friend` : nameOfUser}:
                                    </p>
                                    <p>{message}</p> 
                                    <span style={{ display: "block", textAlign: "right", color: item.role === 'assistant' ? '#EA4C89' : '#49B0E2' }}>
                                        {timeElement}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Col>
        </>
    );
};
export default IndividualConversation;